import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 2560.000000 2417.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,2417.000000) scale(0.100000,-0.100000)">
          <path d="M12395 21459 c-328 -10 -813 -54 -1070 -99 -378 -65 -389 -67 -590
-112 -82 -18 -305 -74 -445 -112 -355 -95 -910 -295 -1265 -456 -38 -17 -101
-46 -140 -63 -80 -36 -486 -240 -559 -282 -28 -15 -72 -41 -98 -56 -27 -16
-50 -29 -52 -29 -15 0 -495 -305 -631 -401 -508 -360 -813 -617 -1240 -1044
-266 -265 -337 -342 -574 -625 -154 -183 -342 -429 -451 -590 -36 -52 -67 -97
-70 -100 -3 -3 -26 -36 -51 -75 -577 -870 -1010 -1858 -1264 -2884 -54 -222
-126 -572 -145 -708 -100 -736 -114 -940 -107 -1563 5 -437 16 -648 52 -940
25 -202 65 -481 76 -530 5 -25 23 -115 40 -200 30 -159 37 -188 87 -395 34
-136 99 -377 112 -415 5 -14 23 -72 40 -130 18 -58 36 -114 40 -125 5 -11 25
-69 46 -130 49 -147 184 -499 231 -605 9 -19 23 -53 33 -75 73 -173 289 -608
393 -790 40 -72 76 -137 80 -145 4 -8 13 -24 20 -35 7 -11 36 -60 66 -110 44
-74 307 -476 333 -510 5 -5 72 -95 149 -200 119 -160 244 -317 345 -435 12
-14 54 -63 94 -110 294 -341 826 -855 1141 -1100 31 -25 95 -75 141 -111 196
-156 477 -351 808 -561 63 -39 329 -191 470 -267 134 -73 363 -184 575 -281
336 -153 886 -353 1235 -450 300 -82 599 -151 845 -194 83 -15 173 -31 200
-36 88 -17 434 -59 615 -74 567 -49 1152 -46 1715 10 438 43 957 134 1335 235
41 12 102 27 135 36 169 42 638 197 875 287 303 117 780 336 1045 481 180 98
254 140 324 183 42 26 89 54 106 62 45 23 405 261 540 358 881 631 1670 1446
2272 2347 111 167 240 370 256 405 4 8 16 29 26 45 102 164 288 519 401 765
266 576 469 1159 605 1735 19 83 40 168 45 190 21 86 83 429 105 585 68 474
86 715 92 1230 7 569 -6 786 -78 1340 -16 124 -34 248 -39 275 -5 28 -28 145
-50 260 -144 752 -417 1552 -779 2288 -218 440 -453 833 -750 1250 -95 133
-408 532 -496 632 -15 17 -54 62 -88 100 -193 220 -566 592 -797 795 -47 41
-94 83 -105 93 -58 53 -421 338 -565 443 -395 289 -855 568 -1285 779 -185 91
-363 175 -371 175 -2 0 -32 13 -66 29 -35 15 -117 49 -183 75 -66 26 -140 56
-165 66 -25 10 -108 41 -185 68 -337 120 -426 147 -905 277 -74 20 -351 80
-480 104 -471 88 -910 135 -1400 151 -173 5 -324 9 -335 8 -11 -1 -132 -5
-270 -9z m735 -89 c242 -12 590 -42 755 -66 159 -22 413 -63 465 -75 25 -5 72
-14 105 -19 251 -40 715 -164 1115 -297 147 -49 208 -72 395 -142 108 -41 261
-104 270 -111 6 -4 21 -11 35 -15 72 -21 759 -355 800 -389 8 -7 41 -26 72
-42 32 -16 58 -32 58 -36 0 -5 5 -8 12 -8 11 0 38 -16 268 -158 121 -75 380
-250 490 -331 162 -119 185 -136 190 -141 3 -3 43 -34 90 -70 210 -159 439
-357 683 -590 49 -47 95 -90 101 -96 229 -232 342 -355 496 -534 656 -767
1170 -1616 1535 -2534 100 -253 98 -247 186 -511 103 -311 222 -748 264 -970
7 -38 25 -129 39 -202 51 -258 96 -590 128 -938 29 -328 32 -1056 5 -1390 -18
-218 -58 -569 -77 -675 -5 -30 -21 -125 -35 -210 -14 -85 -32 -182 -40 -215
-7 -33 -21 -98 -30 -145 -96 -500 -358 -1296 -594 -1803 -23 -49 -41 -90 -41
-93 0 -3 -46 -96 -101 -207 -120 -239 -241 -459 -351 -641 -44 -72 -90 -147
-101 -166 -28 -46 -219 -334 -226 -340 -3 -3 -20 -25 -36 -50 -54 -80 -236
-321 -355 -470 -353 -439 -840 -931 -1260 -1273 -52 -43 -113 -92 -135 -111
-22 -18 -107 -83 -190 -145 -82 -62 -159 -119 -170 -127 -34 -26 -479 -320
-495 -327 -8 -4 -35 -20 -60 -36 -25 -17 -76 -48 -115 -70 -38 -22 -92 -54
-120 -71 -27 -16 -57 -33 -65 -37 -8 -4 -37 -19 -63 -35 -69 -40 -418 -218
-507 -258 -41 -18 -124 -55 -183 -81 -60 -27 -190 -81 -290 -120 -100 -40
-195 -78 -212 -85 -63 -27 -486 -164 -625 -203 -80 -23 -167 -47 -195 -55 -27
-8 -79 -21 -115 -30 -36 -8 -121 -28 -190 -45 -262 -64 -635 -128 -965 -166
-457 -52 -1106 -69 -1566 -41 -251 16 -545 44 -689 66 -435 66 -667 112 -985
194 -230 59 -311 82 -424 117 -53 17 -125 39 -161 50 -210 65 -668 242 -864
333 -39 18 -102 47 -141 64 -120 53 -464 231 -614 318 -79 46 -145 84 -148 84
-2 0 -41 23 -86 51 -351 221 -622 405 -787 534 -163 129 -318 252 -345 276
-16 14 -66 57 -110 94 -542 464 -1091 1080 -1527 1714 -129 189 -365 569 -445
719 -13 24 -36 67 -53 96 -72 130 -262 523 -329 681 -5 11 -19 43 -31 70 -13
28 -36 84 -52 125 -17 41 -36 89 -43 105 -100 241 -281 801 -340 1055 -8 30
-22 91 -33 135 -234 933 -308 2022 -206 3020 80 790 249 1508 539 2289 186
503 507 1150 798 1605 175 276 385 577 498 716 10 11 56 70 105 130 105 133
165 205 219 265 22 25 74 84 115 130 41 47 133 145 205 219 71 73 135 139 141
145 90 94 404 379 569 517 418 348 994 744 1380 949 28 15 83 46 124 69 94 53
361 187 466 234 44 19 127 56 184 82 501 224 1197 448 1738 559 541 111 952
163 1498 189 155 8 592 6 785 -3z"/>
<path d="M13960 18247 c-31 -19 -76 -49 -102 -68 -25 -19 -82 -56 -127 -83
-44 -26 -88 -57 -97 -67 -9 -11 -22 -19 -27 -19 -6 0 -25 -12 -44 -26 -18 -14
-53 -34 -77 -45 -24 -10 -49 -26 -57 -35 -7 -8 -39 -29 -70 -45 -32 -16 -61
-34 -64 -40 -4 -6 -26 -19 -49 -30 -48 -22 -137 -78 -164 -102 -10 -9 -23 -17
-29 -17 -5 0 -29 -14 -52 -30 -23 -17 -65 -42 -94 -56 -68 -33 -160 -85 -182
-104 -18 -16 -69 -44 -190 -106 -38 -19 -95 -50 -126 -67 -31 -18 -71 -41 -90
-51 -206 -118 -501 -269 -589 -303 -36 -13 -72 -31 -81 -39 -9 -8 -44 -25 -79
-39 -34 -13 -68 -29 -75 -35 -7 -6 -41 -19 -76 -31 -35 -11 -80 -32 -100 -45
-20 -14 -54 -28 -75 -31 -51 -8 -74 -35 -74 -86 0 -37 7 -47 76 -116 71 -72
194 -237 194 -260 0 -6 4 -19 9 -29 59 -111 116 -272 141 -397 6 -33 22 -96
35 -140 50 -167 48 -68 52 -4025 3 -3407 4 -3718 19 -3752 11 -25 26 -40 47
-48 48 -16 2269 -13 2292 4 9 7 21 32 26 57 4 24 8 589 9 1255 0 956 3 1214
13 1227 11 17 14 17 37 0 32 -24 86 -79 241 -250 149 -164 277 -300 433 -464
61 -63 154 -162 206 -219 52 -56 127 -135 165 -175 59 -60 190 -202 245 -265
8 -10 67 -73 130 -141 63 -68 149 -159 190 -204 41 -44 140 -150 220 -235 81
-85 178 -189 216 -230 38 -41 108 -115 155 -165 47 -49 103 -110 125 -134 21
-24 57 -56 79 -70 l40 -26 1376 0 c1340 0 1377 1 1398 19 12 11 21 24 21 30
-1 12 -52 75 -120 146 -57 59 -131 140 -240 260 -47 52 -113 124 -146 160 -34
36 -92 101 -130 145 -37 44 -104 118 -148 165 -45 47 -115 123 -156 170 -41
46 -88 98 -105 115 -16 17 -63 68 -103 112 -41 44 -90 98 -110 120 -39 41
-117 130 -197 223 -27 30 -78 87 -115 125 -37 39 -89 95 -116 125 -65 75 -89
102 -159 175 -33 35 -91 98 -130 141 -38 43 -100 110 -136 148 -197 212 -363
396 -367 406 -2 5 -22 28 -45 52 -47 49 -129 138 -232 254 -38 43 -86 95 -105
114 -19 20 -51 55 -70 77 -19 22 -64 72 -100 111 -36 38 -87 96 -115 127 -27
32 -78 87 -112 124 -76 80 -122 130 -188 206 -27 32 -88 97 -134 146 -47 49
-92 101 -102 115 -9 14 -32 40 -50 58 -19 18 -63 66 -99 106 -36 40 -73 80
-83 90 -29 27 -32 31 -79 83 -24 27 -59 65 -78 85 -19 21 -53 59 -76 85 l-41
49 -57 -7 c-49 -6 -63 -13 -89 -43 -50 -56 -104 -114 -137 -148 -16 -16 -30
-34 -30 -38 0 -4 -15 -22 -32 -41 -52 -53 -98 -111 -98 -123 0 -6 -12 -17 -27
-24 -15 -7 -33 -24 -40 -38 -7 -13 -18 -29 -25 -35 -7 -5 -29 -30 -48 -55 -19
-25 -47 -57 -62 -72 -16 -14 -28 -33 -28 -41 0 -9 -9 -19 -20 -22 -11 -4 -27
-19 -35 -35 -8 -15 -28 -42 -44 -60 -31 -33 -32 -34 -69 -72 -46 -47 -82 -91
-87 -108 -3 -9 -17 -22 -30 -28 -14 -6 -25 -16 -25 -22 0 -28 -98 -113 -112
-97 -2 1 -5 1541 -8 3423 -5 3580 -4 3454 -44 3454 -6 0 -36 -15 -66 -33z"/>
<path d="M9489 15091 c-8 -6 -101 -17 -205 -26 -104 -9 -225 -25 -269 -35
-146 -34 -305 -79 -328 -94 -12 -8 -47 -21 -77 -30 -31 -8 -83 -29 -115 -46
-33 -16 -67 -30 -76 -30 -8 0 -35 -13 -60 -28 -24 -15 -60 -34 -79 -42 -19 -7
-44 -20 -55 -29 -11 -9 -41 -27 -67 -39 -25 -13 -55 -32 -66 -42 -10 -10 -33
-25 -50 -34 -17 -9 -35 -22 -39 -29 -4 -7 -24 -24 -43 -37 -147 -103 -400
-356 -450 -450 -7 -14 -26 -41 -42 -60 -15 -19 -28 -39 -28 -44 0 -5 -13 -30
-29 -55 -16 -25 -34 -64 -41 -86 -6 -22 -20 -57 -31 -77 -53 -99 -73 -358 -44
-559 14 -97 65 -263 102 -334 40 -75 67 -124 95 -170 34 -55 241 -261 272
-271 10 -3 39 -21 63 -40 25 -19 49 -34 55 -34 5 0 33 -12 62 -26 59 -31 232
-79 356 -101 113 -19 303 -11 391 17 35 12 91 28 123 36 33 9 72 24 86 33 14
10 45 27 70 38 123 55 286 188 369 303 178 247 241 425 241 680 0 123 -34 321
-66 383 -8 18 -25 57 -36 87 -10 30 -28 73 -38 95 -23 48 -67 198 -82 275 -16
87 -3 249 31 395 34 147 98 282 170 360 64 69 53 136 -25 150 -16 3 -36 1 -45
-4z"/>
<path d="M17695 14949 c-33 -10 -91 -23 -130 -29 -73 -11 -106 -21 -188 -58
-27 -12 -57 -22 -67 -22 -31 0 -352 -153 -432 -206 -29 -19 -57 -34 -62 -34
-5 0 -19 -9 -30 -19 -23 -22 -69 -56 -131 -97 -144 -97 -469 -426 -535 -543
-8 -15 -24 -37 -35 -49 -34 -38 -155 -244 -181 -306 -13 -33 -22 -68 -18 -78
9 -29 62 -37 140 -22 152 29 365 10 506 -46 190 -76 333 -176 504 -352 173
-178 279 -258 419 -314 131 -52 136 -53 301 -74 139 -18 161 -18 293 -5 155
16 211 29 285 69 27 14 55 26 61 26 7 0 36 16 65 35 29 19 55 35 58 35 4 0 32
17 62 37 100 67 313 303 334 370 4 12 17 36 29 55 13 18 43 89 67 158 l44 125
4 188 c5 196 -4 277 -38 347 -10 19 -27 65 -39 102 -22 69 -35 92 -120 213
-62 88 -245 281 -285 302 -17 9 -46 29 -64 44 -18 16 -38 29 -45 29 -6 0 -37
16 -68 35 -31 19 -85 41 -120 49 -35 8 -95 24 -134 35 -96 29 -359 29 -450 0z"/>
<path d="M9985 11509 c-55 -4 -237 -8 -405 -8 -436 -2 -790 -10 -900 -21 -52
-5 -138 -12 -190 -15 -122 -8 -262 -30 -342 -55 -35 -10 -99 -26 -143 -35 -44
-9 -89 -22 -100 -29 -11 -8 -56 -23 -100 -35 -44 -12 -87 -28 -95 -35 -8 -7
-41 -23 -72 -35 -32 -13 -62 -29 -69 -37 -6 -7 -36 -23 -67 -34 -30 -12 -67
-29 -81 -39 -14 -10 -44 -28 -66 -39 -22 -11 -49 -29 -60 -39 -11 -10 -38 -30
-60 -45 -86 -59 -283 -269 -358 -383 -15 -22 -38 -56 -51 -75 -14 -19 -25 -41
-25 -47 -1 -7 -14 -34 -30 -60 -16 -27 -32 -61 -35 -78 -4 -16 -16 -49 -27
-73 -11 -24 -27 -73 -35 -110 -8 -37 -24 -94 -35 -127 -29 -91 -43 -250 -35
-420 3 -82 11 -168 17 -190 6 -22 14 -58 19 -80 27 -133 53 -234 71 -273 12
-25 27 -66 35 -91 7 -26 25 -62 39 -81 14 -18 25 -39 25 -46 0 -6 40 -65 89
-130 84 -112 251 -283 338 -347 68 -51 176 -117 189 -117 7 0 25 -10 41 -23
15 -13 48 -31 73 -41 25 -10 59 -26 75 -36 17 -9 62 -27 100 -39 39 -13 79
-29 91 -36 11 -7 41 -19 65 -25 24 -6 91 -24 149 -40 58 -16 155 -36 215 -44
61 -9 126 -20 145 -26 91 -27 474 -41 1071 -38 539 3 597 5 625 20 31 17 44
36 44 63 0 19 -34 24 -55 9 -20 -15 -65 -19 -65 -6 0 14 -66 52 -91 52 -30 1
-59 22 -59 44 0 9 -8 16 -20 16 -11 0 -36 7 -55 14 -38 16 -47 48 -20 64 20
11 10 38 -16 45 -12 3 -23 -2 -29 -14 -6 -10 -17 -19 -25 -19 -22 0 -23 23 -1
41 l21 17 -24 26 c-29 31 -42 33 -59 6 -13 -22 -32 -19 -32 6 0 8 7 14 15 14
24 0 6 26 -85 120 -45 46 -92 98 -104 116 -11 17 -46 65 -78 105 -31 41 -71
101 -89 134 -69 128 -127 252 -134 285 -4 19 -16 52 -27 73 -17 35 -37 113
-74 297 -32 161 -27 502 10 655 8 33 22 92 31 130 41 176 160 434 264 569 25
33 58 78 73 100 46 69 204 221 321 309 65 49 163 111 233 147 120 61 193 118
180 139 -4 6 -15 10 -24 9 -9 0 -62 -5 -117 -9z"/>
<path d="M9865 8160 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M12343 7279 c-148 -29 -233 -118 -233 -245 0 -116 67 -178 251 -230
149 -42 189 -67 189 -119 0 -43 -29 -67 -89 -73 -81 -7 -205 31 -292 91 l-36
24 -37 -75 c-36 -71 -36 -75 -19 -94 49 -55 245 -118 365 -118 241 1 391 171
303 346 -31 63 -92 104 -205 139 -140 43 -194 68 -208 97 -28 60 32 107 121
93 49 -7 158 -42 196 -61 14 -8 31 -14 36 -14 10 0 75 131 75 151 0 17 -121
66 -203 83 -82 17 -147 19 -214 5z"/>
<path d="M16440 7276 c-96 -27 -159 -74 -195 -145 -13 -25 -16 -52 -13 -106 3
-60 8 -78 31 -108 33 -43 139 -96 241 -121 118 -29 166 -61 166 -111 0 -54
-29 -70 -124 -69 -88 1 -150 20 -239 75 -26 16 -51 29 -55 29 -9 -1 -77 -148
-71 -154 16 -16 130 -78 159 -87 185 -56 328 -50 439 18 84 52 122 137 106
239 -5 39 -16 56 -58 98 -48 48 -62 55 -182 95 -157 53 -183 65 -197 96 -17
38 3 71 52 86 34 11 52 9 126 -9 48 -12 104 -31 126 -42 21 -11 43 -20 48 -20
6 0 27 34 48 76 43 88 43 87 -57 125 -125 47 -259 60 -351 35z"/>
<path d="M7840 7254 c-6 -15 -85 -199 -175 -410 -91 -211 -165 -388 -165 -394
0 -7 35 -10 102 -8 l103 3 28 70 c15 38 33 72 39 76 16 10 350 11 364 1 6 -4
21 -34 33 -67 12 -33 27 -65 33 -72 12 -14 203 -19 212 -5 2 4 -13 48 -35 97
-21 50 -99 234 -173 410 l-134 320 -111 3 -111 3 -10 -27z m155 -276 c14 -40
33 -89 42 -108 8 -19 21 -52 28 -72 17 -47 13 -48 -117 -47 -77 1 -101 4 -105
15 -5 13 49 173 67 199 4 6 13 27 19 48 7 20 19 37 26 37 7 0 25 -32 40 -72z"/>
<path d="M8520 7273 c-4 -80 1 -817 5 -823 7 -11 495 -14 533 -4 21 6 22 12
22 90 l0 84 -177 2 -178 3 -3 328 -2 327 -100 0 c-55 0 -100 -3 -100 -7z"/>
<path d="M9202 6863 l3 -418 100 0 100 0 3 418 2 417 -105 0 -105 0 2 -417z"/>
<path d="M9585 7268 c-3 -7 -4 -195 -3 -418 l3 -405 100 0 100 0 5 106 5 106
47 51 c25 29 52 52 60 52 8 0 61 -69 118 -152 57 -84 109 -156 114 -160 15
-10 236 -10 236 0 0 7 -197 303 -220 329 -5 7 -10 15 -10 18 0 3 -17 29 -38
58 -22 29 -41 59 -44 67 -4 12 54 93 92 130 3 3 39 43 80 90 41 47 77 87 80
90 3 3 14 15 24 28 l19 22 -119 -1 -119 0 -85 -101 c-47 -55 -93 -110 -103
-122 -11 -11 -40 -47 -65 -78 -26 -32 -53 -58 -59 -58 -9 0 -13 45 -15 178
l-3 177 -98 3 c-72 2 -99 -1 -102 -10z"/>
<path d="M10502 6863 l3 -418 276 -3 c216 -2 278 0 281 10 2 7 2 48 0 90 l-4
78 -176 2 -177 3 -3 328 -2 327 -100 0 -100 0 2 -417z"/>
<path d="M11450 7258 c-5 -13 -38 -90 -74 -173 -167 -388 -266 -624 -266 -634
0 -13 179 -15 195 -3 6 4 21 34 34 67 13 33 28 66 34 73 7 9 53 12 191 10
l180 -3 13 -25 c7 -14 23 -47 35 -75 l23 -50 103 -3 c63 -2 102 1 102 7 0 11
-32 89 -194 476 -54 127 -109 258 -123 293 l-27 62 -108 0 c-103 0 -109 -1
-118 -22z m136 -230 c3 -13 27 -74 51 -137 24 -62 42 -120 39 -127 -4 -11 -30
-14 -108 -14 -57 0 -109 4 -117 9 -11 7 -5 31 34 127 26 66 51 129 56 142 5
12 15 22 23 22 8 0 18 -10 22 -22z"/>
<path d="M12902 6863 l3 -418 210 0 c220 0 282 9 360 48 102 51 171 128 206
229 23 65 25 191 4 267 -26 99 -113 202 -205 243 -93 42 -138 48 -362 48
l-218 0 2 -417z m453 223 c93 -44 135 -117 135 -236 0 -86 -35 -158 -98 -204
-42 -30 -48 -31 -163 -35 l-119 -3 0 251 0 251 98 0 c81 0 105 -4 147 -24z"/>
<path d="M13991 7057 c-52 -122 -107 -249 -121 -282 -15 -33 -52 -118 -83
-190 -64 -150 -67 -143 55 -144 90 -1 96 3 128 88 27 74 24 73 245 69 l160 -3
28 -70 c15 -38 32 -72 38 -75 5 -4 55 -8 110 -9 100 -2 101 -2 94 20 -4 12
-45 110 -90 218 -46 108 -113 268 -150 356 -37 88 -75 179 -85 203 l-19 42
-108 0 -108 0 -94 -223z m266 -150 c30 -75 51 -142 48 -147 -3 -5 -57 -9 -120
-8 -90 1 -115 4 -115 14 0 8 24 75 53 149 35 91 57 135 66 133 7 -2 38 -65 68
-141z"/>
<path d="M14580 7195 l0 -84 123 -3 122 -3 5 -330 5 -330 80 -3 c134 -5 120
-41 117 314 -2 170 -1 318 3 331 5 22 8 23 130 23 l125 0 0 85 0 85 -355 0
-355 0 0 -85z"/>
<path d="M15583 7268 c-18 -29 -351 -814 -347 -819 2 -4 48 -7 102 -8 l99 -2
27 75 c15 41 34 77 43 80 8 3 93 6 189 6 l173 0 14 -27 c8 -16 20 -46 27 -68
7 -22 19 -46 28 -52 18 -14 197 -18 206 -5 2 4 -6 33 -19 62 -13 30 -65 154
-115 275 -50 121 -100 240 -111 264 -11 24 -29 67 -40 95 -11 28 -29 70 -40
94 l-19 42 -104 0 c-73 0 -107 -4 -113 -12z m174 -362 c35 -90 50 -142 43
-146 -14 -9 -195 -13 -220 -5 -16 5 -18 10 -8 33 29 71 37 93 68 175 23 60 39
87 48 85 9 -2 38 -62 69 -142z"/>
<path d="M17014 7266 c-11 -28 3 -549 15 -592 26 -86 130 -188 219 -214 20 -6
71 -14 112 -17 175 -13 309 57 377 196 l28 56 0 290 0 290 -102 3 -103 3 0
-267 c0 -250 -1 -270 -21 -310 -28 -60 -71 -84 -146 -84 -66 0 -108 21 -147
73 -20 27 -21 44 -26 305 l-5 277 -98 3 c-79 2 -98 0 -103 -12z"/>
<path d="M17942 6863 l3 -418 245 1 c226 1 250 3 310 23 119 41 180 132 165
243 -9 62 -55 125 -113 153 -23 11 -42 23 -42 27 0 3 20 18 44 32 52 30 86 91
86 153 0 78 -49 139 -139 175 -52 21 -75 23 -309 26 l-252 4 2 -419z m452 235
c41 -36 44 -79 9 -117 l-28 -32 -115 -1 -115 0 -3 73 c-2 39 -1 78 2 86 4 10
32 13 115 13 100 0 112 -2 135 -22z m22 -324 c55 -40 47 -125 -14 -154 -41
-19 -242 -26 -253 -9 -11 17 -12 173 -2 183 5 4 60 6 125 4 99 -3 121 -6 144
-24z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
